import React from 'react';

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error('ErrorBoundary caught:', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center px-6" style={{ background: '#FDFBF7' }} data-testid="error-boundary-fallback">
          <div className="max-w-md text-center">
            <h1 className="font-heading text-3xl font-bold mb-4" style={{ color: '#2A1E5C' }}>
              Something went sideways.
            </h1>
            <p className="font-body text-base mb-8" style={{ color: '#5D5A6B' }}>
              Reload the page to pick up where you left off. Your progress is saved.
            </p>
            <button
              onClick={() => window.location.reload()}
              className="px-8 py-4 rounded-xl font-heading font-bold text-lg transition-all hover:scale-[1.02]"
              style={{ background: '#F5CB5C', color: '#2A1E5C' }}
              data-testid="error-boundary-reload"
            >
              Reload the page
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
